export const REMOVE_CARD_WARNING_TITLE =
    'Are you sure you want to delete this payment method?'
export const REMOVE_CARD_WARNING_BUTTON_TEXT = 'Delete payment'
